import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/affiliate`;

// Meta
export const getAffiliateMeta = () => axios.get(`${BASE}/meta`);

// Tiers
export const getTiers = () => axios.get(`${BASE}/tiers`);
export const createTier = (data) => axios.post(`${BASE}/tiers`, data);
export const updateTier = (id, data) => axios.patch(`${BASE}/tiers/${id}`, data);
export const deleteTier = (id) => axios.delete(`${BASE}/tiers/${id}`);

// Affiliates
export const getAffiliates = (params = {}) => axios.get(`${BASE}/affiliates`, {params});
export const getAffiliate = (id) => axios.get(`${BASE}/affiliates/${id}`);
export const createAffiliate = (data) => axios.post(`${BASE}/affiliates`, data);
export const updateAffiliate = (id, data) => axios.patch(`${BASE}/affiliates/${id}`, data);
export const deleteAffiliate = (id) => axios.delete(`${BASE}/affiliates/${id}`);

// Orders
export const getAffiliateOrders = (params = {}) => axios.get(`${BASE}/orders`, {params});
export const createAffiliateOrder = (data) => axios.post(`${BASE}/orders`, data);
export const updateAffiliateOrder = (id, data) => axios.patch(`${BASE}/orders/${id}`, data);
export const deleteAffiliateOrder = (id) => axios.delete(`${BASE}/orders/${id}`);

// Withdrawals
export const getWithdrawals = (params = {}) => axios.get(`${BASE}/withdrawals`, {params});
export const createWithdrawal = (data) => axios.post(`${BASE}/withdrawals`, data);
export const updateWithdrawal = (id, data) => axios.patch(`${BASE}/withdrawals/${id}`, data);
export const deleteWithdrawal = (id) => axios.delete(`${BASE}/withdrawals/${id}`);
